import FieldsetContractLifecycle from './FieldsetContractLifecycle.yaml?component';
import UcContractLifecycle from './UcContractLifecycle.yaml?component';

export {
  FieldsetContractLifecycle,
  UcContractLifecycle
};
